import type { FormQuestionType } from '@percent/admin-dashboard/api/actions/grantProgram/grantProgram.types'

export const HEX_COLOR_REGEX = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/

export const TYPES_WITH_CONDITIONALS: FormQuestionType[] = ['select', 'radio', 'checkbox']

type QuestionWithOptions = {
  id: string
  options?: { conditionalQuestionIds?: string[] }[]
}

export function getConditionalTargetIds(questions: QuestionWithOptions[]): Set<string> {
  return new Set(questions.flatMap(q => (q.options ?? []).flatMap(o => o.conditionalQuestionIds ?? [])))
}

export function hasConditionalOptions(question: QuestionWithOptions): boolean {
  return (question.options ?? []).some(o => (o.conditionalQuestionIds ?? []).length > 0)
}

export const QUESTION_TYPE_LABELS: Record<string, string> = {
  text: 'Short text',
  textarea: 'Long text',
  number: 'Number',
  email: 'Email',
  name: 'Name',
  select: 'Select',
  radio: 'Radio',
  checkbox: 'Checkbox',
  date: 'Date',
  documents: 'Documents',
  website: 'Website',
  country_search: 'Country search',
  registry_search: 'Registry search',
  organisation_search: 'Organisation search',
  score: 'Score',
  decision: 'Decision',
  award_amount: 'Award amount',
  final_award_amount: 'Final award amount',
  award_recommendation: 'Award recommendation'
}
